import React, { useEffect } from 'react';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import { Text, View } from 'react-native-web';
import PropTypes from 'prop-types';
import styles from './styles';

const propTypes = {
  status: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  setShowAlert: PropTypes.func,
};

const defaultProps = {
  setShowAlert: () => undefined,
};

const CustomAlert = ({ status, message, setShowAlert }) => {
  useEffect(() => {
    const alertTimeout = setTimeout(() => setShowAlert(false), 3000);
    return () => clearTimeout(alertTimeout);
  }, [setShowAlert]);

  return (
    <Alert variant="subtle" status={status} style={styles.alertContainer}>
      <View style={styles.alert}>
        <Alert.Icon />
        <Text style={styles.alertMessage}>{message}</Text>
      </View>
      <Button style={styles.alertClose} onClick={() => setShowAlert(false)}>
        x
      </Button>
    </Alert>
  );
};

CustomAlert.propTypes = propTypes;
CustomAlert.defaultProps = defaultProps;

export default CustomAlert;
